export default __webpack_public_path__ + "static/id-fraud-img-1-29bb03fd51c5ef5ce36cfb342419f7e7.svg";